import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  QueryReceiptScheduleDto,
  ReceiptScheduleItem,
  ReceiptSchedulePageResult,
} from './types/receipt-schedule';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/receipt-schedules';

export async function queryReceiptSchedules(
  params: QueryReceiptScheduleDto,
  options?: ApiRequestOptions,
) {
  return request<ReceiptSchedulePageResult>(BASE_PATH, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getReceiptScheduleDetail(
  uuid: string,
  options?: ApiRequestOptions,
) {
  return request<ReceiptScheduleItem>(`${BASE_PATH}/${uuid}`, {
    method: 'GET',
    ...(options || {}),
  });
}
